import { COUNTRY_CURRENCIES } from "@reactive-resume/utils";

import type { CountryPreference } from "@/client/stores/country-preference";

export type CurrencyPreference = {
  code: string;
  label: string;
  zone: string;
  flagCode: string;
  locale: string;

  /**
   * Nombre de décimales utilisées
   * lors de l’affichage des prix.
   */
  decimals: number;
};

export const COUNTRY_NOT_PROVIDED_CODE =
  "NOT_PROVIDED";

export const pricingCurrencies: CurrencyPreference[] = [
  {
    code: "XOF",
    label: "Franc CFA BCEAO",
    zone: "Afrique de l’Ouest",
    flagCode: "sn",
    locale: "fr-SN",
    decimals: 0,
  },
  {
    code: "XAF",
    label: "Franc CFA BEAC",
    zone: "Afrique centrale",
    flagCode: "cm",
    locale: "fr-CM",
    decimals: 0,
  },
  {
    code: "ZAR",
    label: "Rand",
    zone: "Afrique du Sud",
    flagCode: "za",
    locale: "en-ZA",
    decimals: 2,
  },
  {
    code: "DZD",
    label: "Dinar algérien",
    zone: "Algérie",
    flagCode: "dz",
    locale: "fr-DZ",
    decimals: 2,
  },
  {
    code: "AOA",
    label: "Kwanza",
    zone: "Angola",
    flagCode: "ao",
    locale: "pt-AO",
    decimals: 0,
  },
  {
    code: "BWP",
    label: "Pula",
    zone: "Botswana",
    flagCode: "bw",
    locale: "en-BW",
    decimals: 2,
  },
  {
    code: "BIF",
    label: "Franc burundais",
    zone: "Burundi",
    flagCode: "bi",
    locale: "fr-BI",
    decimals: 0,
  },
  {
    code: "CVE",
    label: "Escudo cap-verdien",
    zone: "Cap-Vert",
    flagCode: "cv",
    locale: "pt-CV",
    decimals: 0,
  },
  {
    code: "KMF",
    label: "Franc comorien",
    zone: "Comores",
    flagCode: "km",
    locale: "fr-KM",
    decimals: 0,
  },
  {
    code: "CDF",
    label: "Franc congolais",
    zone: "République démocratique du Congo",
    flagCode: "cd",
    locale: "fr-CD",
    decimals: 0,
  },
  {
    code: "DJF",
    label: "Franc djiboutien",
    zone: "Djibouti",
    flagCode: "dj",
    locale: "fr-DJ",
    decimals: 0,
  },
  {
    code: "EGP",
    label: "Livre égyptienne",
    zone: "Égypte",
    flagCode: "eg",
    locale: "ar-EG",
    decimals: 2,
  },
  {
    code: "ERN",
    label: "Nakfa",
    zone: "Érythrée",
    flagCode: "er",
    locale: "en-ER",
    decimals: 2,
  },
  {
    code: "SZL",
    label: "Lilangeni",
    zone: "Eswatini",
    flagCode: "sz",
    locale: "en-SZ",
    decimals: 2,
  },
  {
    code: "ETB",
    label: "Birr éthiopien",
    zone: "Éthiopie",
    flagCode: "et",
    locale: "en-ET",
    decimals: 2,
  },
  {
    code: "GMD",
    label: "Dalasi",
    zone: "Gambie",
    flagCode: "gm",
    locale: "en-GM",
    decimals: 2,
  },
  {
    code: "GHS",
    label: "Cedi ghanéen",
    zone: "Ghana",
    flagCode: "gh",
    locale: "en-GH",
    decimals: 2,
  },
  {
    code: "GNF",
    label: "Franc guinéen",
    zone: "Guinée",
    flagCode: "gn",
    locale: "fr-GN",
    decimals: 0,
  },
  {
    code: "KES",
    label: "Shilling kényan",
    zone: "Kenya",
    flagCode: "ke",
    locale: "en-KE",
    decimals: 0,
  },
  {
    code: "LSL",
    label: "Loti",
    zone: "Lesotho",
    flagCode: "ls",
    locale: "en-LS",
    decimals: 2,
  },
  {
    code: "LRD",
    label: "Dollar libérien",
    zone: "Libéria",
    flagCode: "lr",
    locale: "en-LR",
    decimals: 0,
  },
  {
    code: "LYD",
    label: "Dinar libyen",
    zone: "Libye",
    flagCode: "ly",
    locale: "ar-LY",
    decimals: 3,
  },
  {
    code: "MGA",
    label: "Ariary malgache",
    zone: "Madagascar",
    flagCode: "mg",
    locale: "fr-MG",
    decimals: 0,
  },
  {
    code: "MWK",
    label: "Kwacha malawite",
    zone: "Malawi",
    flagCode: "mw",
    locale: "en-MW",
    decimals: 0,
  },
  {
    code: "MAD",
    label: "Dirham marocain",
    zone: "Maroc",
    flagCode: "ma",
    locale: "fr-MA",
    decimals: 2,
  },
  {
    code: "MUR",
    label: "Roupie mauricienne",
    zone: "Maurice",
    flagCode: "mu",
    locale: "fr-MU",
    decimals: 2,
  },
  {
    code: "MRU",
    label: "Ouguiya",
    zone: "Mauritanie",
    flagCode: "mr",
    locale: "fr-MR",
    decimals: 2,
  },
  {
    code: "MZN",
    label: "Metical",
    zone: "Mozambique",
    flagCode: "mz",
    locale: "pt-MZ",
    decimals: 2,
  },
  {
    code: "NAD",
    label: "Dollar namibien",
    zone: "Namibie",
    flagCode: "na",
    locale: "en-NA",
    decimals: 2,
  },
  {
    code: "NGN",
    label: "Naira",
    zone: "Nigeria",
    flagCode: "ng",
    locale: "en-NG",
    decimals: 0,
  },
  {
    code: "UGX",
    label: "Shilling ougandais",
    zone: "Ouganda",
    flagCode: "ug",
    locale: "en-UG",
    decimals: 0,
  },
  {
    code: "RWF",
    label: "Franc rwandais",
    zone: "Rwanda",
    flagCode: "rw",
    locale: "fr-RW",
    decimals: 0,
  },
  {
    code: "STN",
    label: "Dobra",
    zone: "Sao Tomé-et-Principe",
    flagCode: "st",
    locale: "pt-ST",
    decimals: 2,
  },
  {
    code: "SCR",
    label: "Roupie seychelloise",
    zone: "Seychelles",
    flagCode: "sc",
    locale: "fr-SC",
    decimals: 2,
  },
  {
    code: "SLE",
    label: "Leone",
    zone: "Sierra Leone",
    flagCode: "sl",
    locale: "en-SL",
    decimals: 2,
  },
  {
    code: "SOS",
    label: "Shilling somalien",
    zone: "Somalie",
    flagCode: "so",
    locale: "so-SO",
    decimals: 0,
  },
  {
    code: "SDG",
    label: "Livre soudanaise",
    zone: "Soudan",
    flagCode: "sd",
    locale: "ar-SD",
    decimals: 0,
  },
  {
    code: "SSP",
    label: "Livre sud-soudanaise",
    zone: "Soudan du Sud",
    flagCode: "ss",
    locale: "en-SS",
    decimals: 0,
  },
  {
    code: "TZS",
    label: "Shilling tanzanien",
    zone: "Tanzanie",
    flagCode: "tz",
    locale: "sw-TZ",
    decimals: 0,
  },
  {
    code: "TND",
    label: "Dinar tunisien",
    zone: "Tunisie",
    flagCode: "tn",
    locale: "fr-TN",
    decimals: 3,
  },
  {
    code: "ZMW",
    label: "Kwacha zambien",
    zone: "Zambie",
    flagCode: "zm",
    locale: "en-ZM",
    decimals: 2,
  },
  {
    code: "ZWG",
    label: "Zimbabwe Gold",
    zone: "Zimbabwe",
    flagCode: "zw",
    locale: "en-ZW",
    decimals: 2,
  },
  {
    code: "EUR",
    label: "Euro",
    zone: "Zone euro",
    flagCode: "eu",
    locale: "fr-FR",
    decimals: 2,
  },
  {
    code: "USD",
    label: "Dollar américain",
    zone: "International",
    flagCode: "us",
    locale: "en-US",
    decimals: 2,
  },
  {
    code: "CAD",
    label: "Dollar canadien",
    zone: "Canada",
    flagCode: "ca",
    locale: "fr-CA",
    decimals: 2,
  },
  {
    code: "CHF",
    label: "Franc suisse",
    zone: "Suisse",
    flagCode: "ch",
    locale: "fr-CH",
    decimals: 2,
  },
  {
    code: "HTG",
    label: "Gourde haïtienne",
    zone: "Haïti",
    flagCode: "ht",
    locale: "fr-HT",
    decimals: 0,
  },
  {
    code: "LBP",
    label: "Livre libanaise",
    zone: "Liban",
    flagCode: "lb",
    locale: "fr-LB",
    decimals: 0,
  },
  {
    code: "VUV",
    label: "Vatu",
    zone: "Vanuatu",
    flagCode: "vu",
    locale: "fr-VU",
    decimals: 0,
  },
  {
    code: "XPF",
    label: "Franc CFP",
    zone: "Pacifique français",
    flagCode: "pf",
    locale: "fr-PF",
    decimals: 0,
  },
];

export const countryContinents = [
  "Afrique",
  "Europe",
  "Amérique",
  "Asie",
  "Océanie",
] as const;

export type CountryContinent =
  (typeof countryContinents)[number];
export type CountryOption =
  CountryPreference & {
    continent: CountryContinent;
  };

type CountryInput = {
  code: string;
  name: string;
  continent: CountryContinent;
  locale?: string;
};

const getCurrency = (
  currencyCode: string,
): CurrencyPreference => {
  const currency = pricingCurrencies.find(
    (item) => item.code === currencyCode,
  );

  if (!currency) {
    throw new Error(
      `Devise inconnue : ${currencyCode}`,
    );
  }

  return currency;
};

// La devise vient de COUNTRY_CURRENCIES, table partagée avec le serveur.
const createCountry = ({
  code,
  name,
  continent,
  locale,
}: CountryInput): CountryOption => {
  const currency = getCurrency(COUNTRY_CURRENCIES[code]);

  return {
    countryCode: code,
    countryName: name,
    continent,
    currencyCode: currency.code,
    currencyLabel: currency.label,
    flagCode: code.toLowerCase(),
    locale: locale ?? currency.locale,
    countryNotProvided: false,
  };
};

export const countryNotProvided: CountryPreference = {
  countryCode: null,
  countryName: "Pays non renseigné",
  currencyCode: "EUR",
  currencyLabel: "Euro",
  flagCode: "eu",
  locale: "fr-FR",
  countryNotProvided: true,
};

export const countries: CountryOption[] = [
  createCountry({
    code: "ZA",
    name: "Afrique du Sud",
    continent: "Afrique",
  }),
  createCountry({
    code: "DZ",
    name: "Algérie",
    continent: "Afrique",
  }),
  createCountry({
    code: "AO",
    name: "Angola",
    continent: "Afrique",
  }),
  createCountry({
    code: "BJ",
    name: "Bénin",
    continent: "Afrique",
    locale: "fr-BJ",
  }),
  createCountry({
    code: "BW",
    name: "Botswana",
    continent: "Afrique",
  }),
  createCountry({
    code: "BF",
    name: "Burkina Faso",
    continent: "Afrique",
    locale: "fr-BF",
  }),
  createCountry({
    code: "BI",
    name: "Burundi",
    continent: "Afrique",
  }),
  createCountry({
    code: "CM",
    name: "Cameroun",
    continent: "Afrique",
  }),
  createCountry({
    code: "CV",
    name: "Cap-Vert",
    continent: "Afrique",
  }),
  createCountry({
    code: "CF",
    name: "République centrafricaine",
    continent: "Afrique",
    locale: "fr-CF",
  }),
  createCountry({
    code: "KM",
    name: "Comores",
    continent: "Afrique",
  }),
  createCountry({
    code: "CG",
    name: "Congo-Brazzaville",
    continent: "Afrique",
    locale: "fr-CG",
  }),
  createCountry({
    code: "CD",
    name: "République démocratique du Congo",
    continent: "Afrique",
  }),
  createCountry({
    code: "CI",
    name: "Côte d’Ivoire",
    continent: "Afrique",
    locale: "fr-CI",
  }),
  createCountry({
    code: "DJ",
    name: "Djibouti",
    continent: "Afrique",
  }),
  createCountry({
    code: "EG",
    name: "Égypte",
    continent: "Afrique",
  }),
  createCountry({
    code: "ER",
    name: "Érythrée",
    continent: "Afrique",
  }),
  createCountry({
    code: "SZ",
    name: "Eswatini",
    continent: "Afrique",
  }),
  createCountry({
    code: "ET",
    name: "Éthiopie",
    continent: "Afrique",
  }),
  createCountry({
    code: "GA",
    name: "Gabon",
    continent: "Afrique",
    locale: "fr-GA",
  }),
  createCountry({
    code: "GM",
    name: "Gambie",
    continent: "Afrique",
  }),
  createCountry({
    code: "GH",
    name: "Ghana",
    continent: "Afrique",
  }),
  createCountry({
    code: "GN",
    name: "Guinée",
    continent: "Afrique",
  }),
  createCountry({
    code: "GW",
    name: "Guinée-Bissau",
    continent: "Afrique",
    locale: "pt-GW",
  }),
  createCountry({
    code: "GQ",
    name: "Guinée équatoriale",
    continent: "Afrique",
    locale: "es-GQ",
  }),
  createCountry({
    code: "KE",
    name: "Kenya",
    continent: "Afrique",
  }),
  createCountry({
    code: "LS",
    name: "Lesotho",
    continent: "Afrique",
  }),
  createCountry({
    code: "LR",
    name: "Libéria",
    continent: "Afrique",
  }),
  createCountry({
    code: "LY",
    name: "Libye",
    continent: "Afrique",
  }),
  createCountry({
    code: "MG",
    name: "Madagascar",
    continent: "Afrique",
  }),
  createCountry({
    code: "MW",
    name: "Malawi",
    continent: "Afrique",
  }),
  createCountry({
    code: "ML",
    name: "Mali",
    continent: "Afrique",
    locale: "fr-ML",
  }),
  createCountry({
    code: "MA",
    name: "Maroc",
    continent: "Afrique",
  }),
  createCountry({
    code: "MU",
    name: "Maurice",
    continent: "Afrique",
  }),
  createCountry({
    code: "MR",
    name: "Mauritanie",
    continent: "Afrique",
  }),
  createCountry({
    code: "MZ",
    name: "Mozambique",
    continent: "Afrique",
  }),
  createCountry({
    code: "NA",
    name: "Namibie",
    continent: "Afrique",
  }),
  createCountry({
    code: "NE",
    name: "Niger",
    continent: "Afrique",
    locale: "fr-NE",
  }),
  createCountry({
    code: "NG",
    name: "Nigeria",
    continent: "Afrique",
  }),
  createCountry({
    code: "UG",
    name: "Ouganda",
    continent: "Afrique",
  }),
  createCountry({
    code: "RW",
    name: "Rwanda",
    continent: "Afrique",
  }),
  createCountry({
    code: "ST",
    name: "Sao Tomé-et-Principe",
    continent: "Afrique",
  }),
  createCountry({
    code: "SN",
    name: "Sénégal",
    continent: "Afrique",
  }),
  createCountry({
    code: "SC",
    name: "Seychelles",
    continent: "Afrique",
  }),
  createCountry({
    code: "SL",
    name: "Sierra Leone",
    continent: "Afrique",
  }),
  createCountry({
    code: "SO",
    name: "Somalie",
    continent: "Afrique",
  }),
  createCountry({
    code: "SD",
    name: "Soudan",
    continent: "Afrique",
  }),
  createCountry({
    code: "SS",
    name: "Soudan du Sud",
    continent: "Afrique",
  }),
  createCountry({
    code: "TZ",
    name: "Tanzanie",
    continent: "Afrique",
  }),
  createCountry({
    code: "TD",
    name: "Tchad",
    continent: "Afrique",
    locale: "fr-TD",
  }),
  createCountry({
    code: "TG",
    name: "Togo",
    continent: "Afrique",
    locale: "fr-TG",
  }),
  createCountry({
    code: "TN",
    name: "Tunisie",
    continent: "Afrique",
  }),
  createCountry({
    code: "ZM",
    name: "Zambie",
    continent: "Afrique",
  }),
  createCountry({
    code: "ZW",
    name: "Zimbabwe",
    continent: "Afrique",
  }),

  createCountry({
    code: "FR",
    name: "France",
    continent: "Europe",
  }),
  createCountry({
    code: "BE",
    name: "Belgique",
    continent: "Europe",
    locale: "fr-BE",
  }),
  createCountry({
    code: "LU",
    name: "Luxembourg",
    continent: "Europe",
    locale: "fr-LU",
  }),
  createCountry({
    code: "MC",
    name: "Monaco",
    continent: "Europe",
    locale: "fr-MC",
  }),
  createCountry({
    code: "ES",
    name: "Espagne",
    continent: "Europe",
    locale: "es-ES",
  }),
  createCountry({
    code: "DE",
    name: "Allemagne",
    continent: "Europe",
    locale: "de-DE",
  }),
  createCountry({
    code: "IT",
    name: "Italie",
    continent: "Europe",
    locale: "it-IT",
  }),
  createCountry({
    code: "PT",
    name: "Portugal",
    continent: "Europe",
    locale: "pt-PT",
  }),
  createCountry({
    code: "NL",
    name: "Pays-Bas",
    continent: "Europe",
    locale: "nl-NL",
  }),
  createCountry({
    code: "IE",
    name: "Irlande",
    continent: "Europe",
    locale: "en-IE",
  }),
  createCountry({
    code: "AT",
    name: "Autriche",
    continent: "Europe",
    locale: "de-AT",
  }),
  createCountry({
    code: "FI",
    name: "Finlande",
    continent: "Europe",
    locale: "fi-FI",
  }),
  createCountry({
    code: "GR",
    name: "Grèce",
    continent: "Europe",
    locale: "el-GR",
  }),
  createCountry({
    code: "CH",
    name: "Suisse",
    continent: "Europe",
  }),

  createCountry({
    code: "US",
    name: "États-Unis",
    continent: "Amérique",
  }),
  createCountry({
    code: "CA",
    name: "Canada",
    continent: "Amérique",
  }),
  createCountry({
    code: "HT",
    name: "Haïti",
    continent: "Amérique",
  }),

  createCountry({
    code: "LB",
    name: "Liban",
    continent: "Asie",
  }),

  createCountry({
    code: "VU",
    name: "Vanuatu",
    continent: "Océanie",
  }),
  createCountry({
    code: "PF",
    name: "Polynésie française",
    continent: "Océanie",
  }),
  createCountry({
    code: "NC",
    name: "Nouvelle-Calédonie",
    continent: "Océanie",
    locale: "fr-NC",
  }),
  createCountry({
    code: "WF",
    name: "Wallis-et-Futuna",
    continent: "Océanie",
    locale: "fr-WF",
  }),
];

export const findCurrency = (
  currencyCode: string,
): CurrencyPreference | undefined =>
  pricingCurrencies.find(
    (currency) =>
      currency.code === currencyCode,
  );

export const findCountry = (
  countryCode: string,
): CountryPreference | undefined =>
  countries.find(
    (country) =>
      country.countryCode === countryCode,
  );